import { useState } from 'react';
import {
  CloseCircle,
  MediaMatch,
  NewTypography as Typography,
  useViewport,
} from '@lamimed/pantheon';
import {
  ChevronLeft,
  ChevronRight,
  HelpCircle,
  Home,
  LogOut,
  Menu,
} from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';

import { whatsappUrl } from 'utils/whatsappUrl';

import { Divider } from 'components/Divider';
import { Drawer } from 'components/Drawer';

import { LogoutDialog } from './containers/LogoutDialog';

import * as S from './styles';

interface Props {
  backButtonRoute: string | null;
}

export function Navigation({ backButtonRoute }: Props) {
  const [menuOpen, menuSetOpen] = useState(false);

  const { greaterThan } = useViewport();

  return (
    <>
      <S.Container>
        <MediaMatch lessThan="desktop">
          <S.BackButtonContainer>
            {backButtonRoute && (
              <Link aria-label="home-button" href={backButtonRoute}>
                <S.BackButton>
                  <ChevronLeft />
                </S.BackButton>
              </Link>
            )}
          </S.BackButtonContainer>
        </MediaMatch>

        <S.Logo
          href="/"
          marginBottom={greaterThan('desktop') ? 'large' : 'none'}
        >
          <Image
            src="/images/logo-new.svg"
            alt="Logo"
            width={170}
            height={40}
          />
        </S.Logo>

        <MediaMatch lessThan="desktop">
          <S.MenuButton onClick={() => menuSetOpen(true)}>
            <Menu />
          </S.MenuButton>
        </MediaMatch>

        <MediaMatch greaterThan="desktop">
          <NavigationMenu />
        </MediaMatch>
      </S.Container>

      <Drawer open={menuOpen} onClose={() => menuSetOpen(false)}>
        <S.LogoContainer>
          <S.Logo href="/">
            <Image
              src="/images/logo-new.svg"
              alt="Logo"
              width={170}
              height={40}
            />
          </S.Logo>

          <CloseCircle
            color="dark"
            width={S.backButtonIconSize}
            height={S.backButtonIconSize}
            onClick={() => menuSetOpen(false)}
          />
        </S.LogoContainer>

        <Divider marginTop="medium" marginBottom="large" />

        <NavigationMenu />
      </Drawer>
    </>
  );
}

function NavigationMenu() {
  const [logoutDialogOpen, logoutDialogSetOpen] = useState(false);

  return (
    <S.MenuContainer>
      <LogoutDialog
        open={logoutDialogOpen}
        onClose={() => logoutDialogSetOpen(false)}
      />

      <S.Menu>
        <S.MenuItem as={Link} aria-label="home-button" href="/patient-area">
          <S.MenuItemContent>
            <Home size={16} />

            <Typography marginBottom="none">Home</Typography>
          </S.MenuItemContent>
        </S.MenuItem>

        <Divider marginTop="small" marginBottom="small" />
      </S.Menu>

      <S.Menu>
        <Divider marginTop="none" marginBottom="none" />

        <S.MenuItem
          as={Link}
          href={whatsappUrl(
            '17275925942',
            'Sono un paziente di Lami e ho bisogno di assistenza',
          )}
          target="_blank"
        >
          <S.MenuItemContent>
            <HelpCircle size={16} />

            <Typography marginBottom="none">Supporto</Typography>
          </S.MenuItemContent>

          <ChevronRight size={16} />
        </S.MenuItem>

        <S.MenuItem onClick={() => logoutDialogSetOpen(true)}>
          <S.MenuItemContent>
            <LogOut size={16} />

            <Typography marginBottom="none">Logout</Typography>
          </S.MenuItemContent>

          <ChevronRight size={16} />
        </S.MenuItem>
      </S.Menu>
    </S.MenuContainer>
  );
}
